import PropTypes from "prop-types";

import Box from "@mui/material/Box";

import Image from "../../../icons/Image";

const ImagePlaceholder = props => {
  const { sx, size, ...others } = props;

  return (
    <Box
      {...others}
      sx={{
        alignItems: "center",
        backgroundColor: "background.imagePlaceholder",
        color: "imagePlaceholder.main",
        display: "flex",
        justifyContent: "center",
        ...sx
      }}
    >
      <Image sx={{ fontSize: size }} />
    </Box>
  );
};

ImagePlaceholder.defaultProps = {
  // height: null,
  // portrait: false,
  size: null,
  sx: null
};

ImagePlaceholder.propTypes = {
  // height: PropTypes.number,
  // portrait: PropTypes.bool,
  size: PropTypes.number,
  sx: PropTypes.object
};

export default ImagePlaceholder;
